import React from 'react'

import { Helmet } from 'react-helmet'

import './section.css'

const Section = (props) => {
  return (
    <div className="section-container">
      <Helmet>
        <title>exported project</title>
      </Helmet>
      <div className="section-section">
        <div className="section-g10">
          <div className="section-clippathgroup">
            <div className="section-clip-path16">
              <img
                alt="path141828"
                src="/external/path141828-omre.svg"
                className="section-path14"
              />
            </div>
            <div className="section-g12">
              <div className="section-container1">
                <div className="section-g18">
                  <img
                    alt="path201810"
                    src="/external/path201810-xisb.svg"
                    className="section-path20"
                  />
                </div>
                <div className="section-g22">
                  <img
                    alt="path241812"
                    src="/external/path241812-99gl.svg"
                    className="section-path24"
                  />
                </div>
              </div>
              <div className="section-container2">
                <div className="section-g34">
                  <img
                    alt="path361818"
                    src="/external/path361818-vhr.svg"
                    className="section-path36"
                  />
                </div>
                <div className="section-g38">
                  <img
                    alt="path401820"
                    src="/external/path401820-4z7q.svg"
                    className="section-path40"
                  />
                </div>
                <div className="section-g42">
                  <img
                    alt="path441822"
                    src="/external/path441822-7mw.svg"
                    className="section-path44"
                  />
                </div>
              </div>
              <div className="section-container3">
                <div className="section-container4">
                  <div className="section-g30">
                    <img
                      alt="path321816"
                      src="/external/path321816-fhr5.svg"
                      className="section-path32"
                    />
                  </div>
                  <div className="section-g46">
                    <img
                      alt="path481824"
                      src="/external/path481824-bcmt.svg"
                      className="section-path48"
                    />
                  </div>
                </div>
              </div>
              <div className="section-container5">
                <div className="section-g26">
                  <img
                    alt="path281814"
                    src="/external/path281814-3mv.svg"
                    className="section-path28"
                  />
                </div>
                <div className="section-g50">
                  <img
                    alt="path521826"
                    src="/external/path521826-tec1j.svg"
                    className="section-path52"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Section
